import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Tab,
  Tabs,
  Switch,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Cookies = ({ open, onClose, onAcceptAll, onModify, setOpen }) => {
  const [policyOpen, setPolicyOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const [cookies, setCookies] = useState({
    functional: true,
    analytical: false,
    promotional: false,
    preferences: false,
  });

  // useEffect(() => {
  //   const isCookieAccepted = localStorage.getItem("cookieAccepted");
  //   if (!isCookieAccepted) {
  //     setOpen(true);
  //   }
  // }, []);

  const handleToggle = (key) => {
    setCookies((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleAcceptAll = () => {
    localStorage.setItem("cookieAccepted", "true");
    setOpen(false);
    setPolicyOpen(false);
    // any additional logic...
  };

  const cookieTypes = [
    {
      key: "functional",
      title: "Functional cookies",
      description:
        "These cookies are essential for the running of our website. Without these cookies our websites would not function properly. These are saved temporarily as login information and expire once the browser is closed.",
    },
    {
      key: "analytical",
      title: "Analytical cookies",
      description:
        "The information provided by analytical cookies allows us to analyse patterns of visitor behaviour and we use that information to enhance the overall experience or identify areas of the website which may require maintenance. The information is anonymous and is only used for statistical purposes.",
    },
    {
      key: "promotional",
      title: "Promotional cookies",
      description:
        "These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and more valuable for publishers and advertisers.",
    },
    {
      key: "preferences",
      title: "Preferences cookies",
      description:
        "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region you are in.",
    },
  ];
  const tabStyle = (selected) => ({
    fontSize: "18px",
    fontWeight: "500",
    textTransform: "none",
    color: selected ? "#19ABE2 !important" : "#667085",
    "&:hover": {
      color: selected ? "#19ABE2" : "#344054",
    },
  });

  return (
    <>
      {/* Main Cookie Consent Dialog */}
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            borderRadius: "18px",
            maxWidth: "750px",
            width: "100%",
            px: 2,
            py: 2,
            boxShadow: "none",
          },
        }}
      >
        <Box display="flex" justifyContent="flex-end">
          <IconButton
            onClick={() => {
              setPolicyOpen(false); // Close policy dialog if open
              onClose(); // Trigger external close logic
            }}
            size="small"
            sx={{
              backgroundColor: "rgba(102, 112, 133, 0.1)", // Soft background
              borderRadius: "50%", // Circle shape
              padding: "6px", // Optional: adjust for tight circle
              "&:hover": {
                backgroundColor: "rgba(102, 112, 133, 0.1)", // Hover effect
              },
            }}
          >
            <CloseIcon sx={{ fontSize: "20px", color: "#344054" }} />
          </IconButton>
        </Box>

        <DialogContent sx={{ px: 3, pt: 0 }}>
          <Box
            display="flex"
            alignItems="start"
            gap={2}
            mb={2}
            flexDirection="column"
          >
            <img
              src="/Images/ckkoo.png"
              alt="logo"
              width="50px"
              height="50px"
            />
            <Typography
              fontWeight="500"
              fontSize="45px"
              fontFamily="SF Pro Display"
            >
              We respect your privacy
            </Typography>
          </Box>

          <Typography
            variant="body2"
            color="#667085"
            fontWeight="400"
            mb={4}
            fontSize={{ xs: "12px", sm: "19px", md: "19px", lg: "19px" }}
            lineHeight="1.6"
          >
            We use cookies to ensure the best possible browsing experience. Some
            are needed for essential features like login sessions, while others
            help us provide you with content and marketing more closely tailored
            to your needs. Accepting all cookies enables us to enhance your
            experience further. Please note, some of these may be third-party
            cookies. You can modify your cookie preferences by clicking the
            button below. For more information, please see our{" "}
            <Box
              component="a"
              href="/Pdf/newRisk.pdf" // Make sure the PDF is in the `public/Pdf/` folder
              target="_blank"
              rel="noopener"
              sx={{
                color: "#19ABE2",
                fontWeight: 500,
                textDecoration: "none",
                listStyle: "none",
                cursor: "pointer",
                display: "inline",
                "&:hover": {
                  textDecoration: "none",
                  color: "#19ABE2",
                  listStyle: "none",
                },
              }}
            >
              Cookie Policy
            </Box>
            .
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ width: "100%" }}
          >
            <Button
              disableRipple
              onClick={() => setPolicyOpen(true)}
              variant="outlined"
              sx={{
                width: { xs: "100%", sm: "27%" },
                height: "50px",
                backgroundColor: "rgba(102, 112, 133, 0.1)",
                color: "#667085",
                borderRadius: "10px",
                fontWeight: 500,
                textTransform: "none",
                fontSize: "15px",
                border: "1px solid #ccc",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "rgba(102, 112, 133, 0.1)",
                  color: "#667085",
                },
              }}
            >
              Modify Preferences
            </Button>

            <Button
              onClick={handleAcceptAll}
              variant="contained"
              sx={{
                width: { xs: "100%", sm: "20%" },
                height: "50px",
                backgroundColor: "#000",
                color: "#fff",
                borderRadius: "10px",
                fontWeight: 400,
                textTransform: "none",
                fontSize: "15px",
                "&:hover": {
                  backgroundColor: "#333",
                },
              }}
            >
              Accept All
            </Button>
          </Stack>
          {/* <Box display="flex" gap={2}>
            <Button
              disableRipple
              onClick={() => setPolicyOpen(true)}
              variant="outlined"
              sx={{
                width: { xs: "100%", md: "27%" },
                height: "50px",
                backgroundColor: "rgba(102, 112, 133, 0.1)",
                color: "#667085",
                borderRadius: "10px",
                fontWeight: 500,
                textTransform: "none",
                fontSize: "15px",
                border: "1px solid #ccc",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "rgba(102, 112, 133, 0.1)",
                  color: "#667085",
                },
              }}
            >
              Modify Preferences
            </Button>

            <Button
              // onClick={() => {
              //   setPolicyOpen(false); // Close policy dialog if open
              //   onAcceptAll(); // Trigger external accept logic
              // }}
              onClick={handleAcceptAll}
              variant="contained"
              sx={{
                width: { xs: "100%", md: "20%" },
                backgroundColor: "#000",
                color: "#fff",
                borderRadius: "10px",
                fontWeight: 400,
                textTransform: "none",
                fontSize: "15px",
                "&:hover": {
                  backgroundColor: "#333",
                },
              }}
            >
              Accept All
            </Button>
          </Box> */}
        </DialogContent>
      </Dialog>

      {/* Second Dialog — Cookie Policy */}
      <Dialog
        open={policyOpen}
        // onClose={() => setPolicyOpen(false)}
        scroll="paper"
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            minHeight: 100,
            // maxHeight: {
            //   xs: tab === 0 || tab === 1 || tab === 2 ? "91.7vh" : "91.7vh", // small devices
            //   md: tab === 0 || tab === 1 || tab === 2 ? "83.7vh" : "90vh", // medium and up
            // },
          },
        }}
      >
        <Box position="relative" px={2} pt={2}>
          <Typography
            fontWeight="500"
            fontSize="40px"
            fontFamily="SF Pro Display"
            mb={2}
          >
            Your cookie settings
          </Typography>

          <IconButton
            onClick={() => {
              setPolicyOpen(false); // Close policy dialog if open
              onAcceptAll(); // Trigger external accept logic
            }}
            size="small"
            sx={{
              position: "absolute",
              top: 15,
              right: 15,
              backgroundColor: "rgba(102, 112, 133, 0.1)", // Soft background
              borderRadius: "50%", // Circle shape
              padding: "6px", // Optional: adjust for tight circle
              "&:hover": {
                backgroundColor: "rgba(102, 112, 133, 0.1)", // Hover effect
              },
            }}
          >
            <CloseIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Box>

        <DialogContent
          sx={{
            p: 0,
            height: {
              xs: "calc(100vh - 200px)", // Adjust based on design
              md: "calc(100vh - 100px)",
            },
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              height: "100%",
              overflowY: "auto",
              px: 3,
              py: 2,
            }}
          >
            <Tabs
              value={tab}
              onChange={(_, val) => setTab(val)}
              variant="scrollable"
              allowScrollButtonsMobile
              TabIndicatorProps={{
                sx: {
                  backgroundColor: "#2494C9",
                  height: 2,
                  borderRadius: 2,
                },
              }}
            >
              <Tab
                disableRipple
                label="Change Settings"
                sx={tabStyle(tab === 0)}
              />
              <Tab
                disableRipple
                label="What are Cookies?"
                sx={tabStyle(tab === 1)}
              />
              <Tab
                disableRipple
                label="Why are cookies useful?"
                sx={tabStyle(tab === 2)}
              />
            </Tabs>

            {tab === 0 && (
              <Box>
                <Typography
                  fontSize="17px"
                  color="text.secondary"
                  mt={3}
                  fontWeight="500"
                >
                  Please select which types of cookies you want to be stored on
                  your device.
                </Typography>

                {cookieTypes.map((cookie) => (
                  <Box key={cookie.key} mt={3}>
                    <Box display="flex" alignItems="center" mb={1}>
                      <Switch
                        checked={cookies[cookie.key]}
                        onChange={() => handleToggle(cookie.key)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#2494C9",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#2494C9",
                          },
                          "& .MuiSwitch-track": {
                            backgroundColor: "#ccc",
                          },
                        }}
                      />
                      <Typography fontWeight="bold">{cookie.title}</Typography>
                    </Box>
                    <Typography
                      color="text.secondary"
                      fontSize="17px"
                      fontWeight="500"
                      marginLeft="60px"
                    >
                      {cookie.description}
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}

            {tab === 1 && (
              <Box mb={{ xs: 2, sm: 9 }} mt={3}>
                <Typography fontWeight="bold">Why are cookies?.</Typography>
                <Typography
                  variant="body2"
                  color="#667085"
                  fontWeight="400"
                  fontSize="17px"
                  lineHeight="1.6"
                  mt={2}
                >
                  Cookies are small data files. When you visit a website, the
                  website sends the cookie to your computer. Your computer
                  stores it in a file located inside your web browser.
                  <br />
                  <br />
                  Cookies do not transfer viruses or malware to your computer.
                  Because the data in a cookie does not change when it travels
                  back and forth, it has no way to affect how your computer
                  runs, but they act more like logs (i.e. they record user
                  activity and remember stateful information) and they get
                  updated every time you visit a website.
                  <br />
                  <br />
                  We may obtain information about you by accessing cookies, sent
                  by our website. Different types of cookies keep track of
                  different activities. For example, session cookies are used
                  only when a person is actively navigating a website. Once you
                  leave the website, the session cookie disappears.{" "}
                </Typography>
              </Box>
            )}

            {tab === 2 && (
              <Box mt={3}>
                <Typography fontWeight="bold">
                  Why are cookies useful?
                </Typography>
                <Typography
                  variant="body2"
                  color="#667085"
                  fontWeight="400"
                  fontSize="17px"
                  lineHeight="1.6"
                  mt={2}
                >
                  We use functional cookies to analyse how visitors use our
                  website, as well as track and improve our website’s
                  performance and function. This allows us to provide a
                  high-quality customer experience by quickly identifying and
                  fixing any issues that may arise.
                  <br />
                  <br />
                  For example, we might use cookies to keep track of which
                  website pages are most popular and which method of linking
                  between website pages is most effective. The latter also helps
                  us to track if you were referred to us by another website and
                  improve our future advertising campaigns.
                  <br />
                  <br />
                  Another use of cookies is to store your log in sessions,
                  meaning that when you log in to the Members Area to deposit
                  funds, a "session cookie" is set so that the website remembers
                  that you have already logged in. If the website did not set
                  this cookie, you will be asked for your login and password on
                  each new page as you progress through the funding process.
                  <br />
                  <br />
                  In addition, functional cookies, for example, are used to
                  allow us to remember your preferences and identify you as a
                  user, ensure your information is secure and operate more
                  reliably and efficiently. For example, cookies save you the
                  trouble of typing in your username every time you access our
                  trading platform, and recall your preferences, such as which
                  language you wish to see when you log in.{" "}
                </Typography>
                <Typography fontWeight="bold" mt={4}>
                  WHere is an overview of some of the functions our cookies
                  provide us with:
                </Typography>
                <Typography
                  variant="body2"
                  color="#667085"
                  fontWeight="400"
                  fontSize="17px"
                  lineHeight="1.6"
                  mt={2}
                >
                  • Verifying your identity and detecting the country you are
                  currently visiting from
                  <br />
                  • Checking browser type and device
                  <br />
                  • Tracking which site the user was referred from
                  <br />
                  • ChaAllowing third parties to customise content accordingly
                  <br />
                  <br /> This website uses Google Analytics, a web analytics
                  service provided by Google, Inc. ("Google"). Google Analytics
                  uses analytical cookies placed on your computer, to help the
                  website analyse a user's use of the website. The information
                  generated by the cookie about your use of the website
                  (including your IP address) may be transmitted to and stored
                  by Google on their servers. Google may use this information to
                  evaluate your use of the website, to compile reports on
                  website activity and to provide other services related to
                  website activity and internet usage. Google may also transfer
                  this information to third parties, where required to do so by
                  law, or where such third parties process the information on
                  behalf of Google. Google will not associate your IP address
                  with any other data held. By using this website, you give your
                  consent to Google to process data about you in the manner and
                  for the purposes set out above.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>

        <Box display="flex" gap={1} p={3} pt={2}>
          <Button
            onClick={onModify}
            variant="outlined"
            sx={{
              width: { xs: "100%", md: "21%" },
              height: "50px",
              backgroundColor: "rgba(102, 112, 133, 0.1)",
              color: "#667085",
              borderRadius: "10px",
              fontWeight: 500,
              textTransform: "none",
              fontSize: "15px",
              border: "1px solid #ccc",
              mr: 2,
              display: tab === 2 || tab === 1 ? "none" : "inline-block",
              "&:hover": {
                backgroundColor: "rgba(102, 112, 133, 0.1)",
                color: "#667085",
              },
            }}
          >
            Modify Preferences
          </Button>

          <Button
            // onClick={() => {
            //   setPolicyOpen(false); // Close policy dialog if open
            //   onAcceptAll(); // Trigger external accept logic
            // }}
            onClick={handleAcceptAll}
            variant="contained"
            sx={{
              width: {
                xs: "100%",
                sm: tab === 2 || tab === 1 ? "32%" : "120px",
              },
              height: "50px",
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "10px",
              fontWeight: 500,
              textTransform: "none",
              fontSize: "15px",
              "&:hover": {
                backgroundColor: "#333",
              },
            }}
          >
            {tab === 2 || tab === 1
              ? "Enable All Cookies and Close"
              : "Accept All"}
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

const tabStyle = (selected) => ({
  color: selected ? "#2494C9" : "gray",
  fontSize: "15px",
  fontWeight: "500",
});

export default Cookies;
